import { GrGithub } from 'react-icons/gr'
import { TbWorld } from 'react-icons/tb'

// images from the asset folder in the image file
import {
  tv,
  lib,
  maths,
  onlineshop,
  todo,
  seminar,
} from "../../assets/images";

// projects' id, name, stacks, icon and url data
export const projects = [
  {
    id: 1,
    name: "Top-rated-tv-shows",
    desc: "Allows users to engage with TV show information via an external API. Users can, like shows and leave comments. It uses an involvement API to save data.",
    stack: "HTML CSS JavaScript React",
    gitHubUrl: {
      icon: <GrGithub />,
      url: "https://github.com/NATASHA-ct/Top-rated-tv-shows-Web-app",
    },
    website: {
      icon: <TbWorld />,
      url: "https://natasha-ct.github.io/Top-rated-tv-shows-Web-app/dist/",
    },
    imgUrl: tv,
  },
  {
    id: 2,
    name: "Daily Planner",
    desc: "A webapp for to-do tasks has functionality to add, remove, mark items as complete, and remove all completed items at once.",
    stack: "HTML CSS JavaScript",
    gitHubUrl: {
      icon: <GrGithub />,
      url: "https://github.com/NATASHA-ct/Daily-planner",
    },
    website: {
      icon: <TbWorld />,
      url: "https://dulcet-churros-bc7c19.netlify.app/",
    },
    imgUrl: todo,
  },
  {
    id: 3,
    name: "Online Shop",
    desc: "Web application for viewing and filtering products via an external API, including product lists and detailed information pages. Users can filter & view metrics for specific criteria.",
    stack: "React  Redux CSS",
    imgUrl: onlineshop,

    gitHubUrl: {
      icon: <GrGithub />,
      url: "https://github.com/NATASHA-ct/onlineshop",
    },
    website: {
      icon: <TbWorld />,
      url: "https://prismatic-banoffee-c996a7.netlify.app/",
    },
  },
  {
    id: 4,
    name: "Digital Library",
    desc: "Web app using React & Redux to view, add, & remove books, tested using Jest. It offers a simple way to manage your book collection.",
    stack: "React.js CSS",
    gitHubUrl: {
      icon: <GrGithub />,
      url: "https://github.com/NATASHA-ct/DigitalLibrary",
    },
    website: {
      icon: <TbWorld />,
      url: "https://deft-seahorse-76e953.netlify.app/",
    },
    imgUrl: lib,
  },

  {
    id: 5,
    name: "Online Math Calculator",
    desc: "Single-page app for math calculations & reading random math-related quotes, offering quick access to simple tools and resources",
    stack: "React.js CSS",
    gitHubUrl: {
      icon: <GrGithub />,
      url: "https://github.com/NATASHA-ct/REACT-Math-Calculator",
    },
    website: {
      icon: <TbWorld />,
      url: "https://phenomenal-rugelach-2147c0.netlify.app/",
    },
    imgUrl: maths,
  },
  {
    id: 6,
    name: "Business-Seminar-Website",
    desc: "A business seminar website with info on dates, speakers, tickets, and location. The goal is to help achieve productivity and balance in work & life.",
    stack: "HTML CSS JavaScript Webpack",
    gitHubUrl: {
      icon: <GrGithub />,
      url: "https://github.com/NATASHA-ct/Business-Seminar-Website",
    },
    website: {
      icon: <TbWorld />,
      url: "https://natasha-ct.github.io/Business-Seminar-Website/",
    },
    imgUrl: seminar,
  },
  // {
  //   id: 4,
  //   name: "Hotel Booking Project",
  //   desc: "A complicated project that enhanced my skills a lot",
  //   stack: "ReactHTML CSS JavaScript Webpack",
  //   gitHubUrl: {
  //     icon: <GrGithub />,
  //     url: "https://github.com/Almarex-Web-Dev/React-booking-project",
  //   },
  //   website: {
  //     icon: <TbWorld />,
  //     url: "https://react-booking-project.netlify.app/",
  //   },
  //   imgUrl:
  //     "https://cdn.dribbble.com/userupload/2512424/file/original-03f9f265f9a4adbd54644841930518a1.png?compress=1&resize=320x240&vertical=top",
  // },
  // {
  //   id: 2,
  //   name: "Restaurant Website",
  //   desc: "A Responsive restaurant website design with great UI Effect",
  //   stack: "React JS",
  //   gitHubUrl: {
  //     icon: <GrGithub />,
  //     url: "https://github.com/Almarex-Web-Dev/Restaurant-Website-project",
  //   },
  //   website: {
  //     icon: <TbWorld />,
  //     url: "https://gericht-restaurant-website.netlify.app/",
  //   },
  //   imgUrl: gericht,
  // },
];
